import type { BoundaryId } from '~/store/boundaries/boundaryIdentifier.type';
import {
  type BoundarySelectState, isBoundarySelectQuickEditCustomBoundary,
} from '~/store/frontendState/mapTools/boundary/boundarySelect/boundarySelect.state';

export const getIsBoundarySelected = (boundarySelectState: BoundarySelectState): ((boundaryId: BoundaryId) => boolean) => {
  return (boundaryId: BoundaryId) => {
    if (isBoundarySelectQuickEditCustomBoundary(boundarySelectState)) {
      const selectedBucketId = boundarySelectState.selectionModeData.selectedBucketId;
      const boundaryAssignedToBoundaryId =
        boundarySelectState.selectedBoundaryInfos.find(boundaryInfo => boundaryInfo.boundaryId === boundaryId)
          ?.selectedBucketId;
      return boundaryAssignedToBoundaryId === selectedBucketId;
    }
    return boundarySelectState.selectedBoundaryInfos?.some(({ boundaryId: selectedBoundaryId }) => selectedBoundaryId === boundaryId) ?? false;
  };
};
